import { useAppSelector } from '../../app/hooks';
import { selectCurrentForm } from '../../app/slices/form.slice';
import styles from '../../assets/css/form.module.css';
import { Form } from '../../fxfs';
import { FormContext } from './form-contexts/FormContext';
import { SubmitButton } from './SubmitButton';
import { useForm } from './useForm';
import { Box } from '@mui/material';
import { selectCurrentSessionState } from '../../app/slices/session.slice';
import { usePolling } from '../redirection/usePolling';
import useCustomization from '../../hooks/useCustomization';
import { selectPreviousStep } from '../../app/slices/step.slice';
import HyperlinkCustomization from '../customizations/HyperlinkCustomization';
import { FC } from 'react';

export const FormStep: FC = () => {
	const { schema, context } = useAppSelector(selectCurrentForm)!;

	const hasPooling = useHasPooling();
	const previousStep = useAppSelector(selectPreviousStep)!;
	const customization = useCustomization('FORWARDING_PAGE_SUBTITLE');

	usePolling();

	const { onChange, onValidationChange, onSubmit, submitting, isSubmitDisabled } = useForm(schema);

	const isPreviousStepBankSelection = previousStep === 'BANK_SELECTION';
	const isSubmitButtonShown = !hasPooling;
	const isCustomizationShown = isPreviousStepBankSelection && customization;
	return (
		<Box id="form-step" key={schema.form_identifier} className={`form-container ${styles['form-container']}`}>
			{context && <FormContext context={context} />}
			<Form form={schema} onChange={onChange} onValidationChange={onValidationChange} />
			{isSubmitButtonShown && (
				<SubmitButton onSubmit={onSubmit} submitting={submitting} disabled={isSubmitDisabled} />
			)}
			{isCustomizationShown && (
				<Box sx={customizationContainerSX}>
					<HyperlinkCustomization content={customization} />
				</Box>
			)}
		</Box>
	);
};

export default FormStep;

const useHasPooling = (): boolean => {
	const state = useAppSelector(selectCurrentSessionState);
	if (state?.status !== 'CONSUMER_INPUT_NEEDED') return false;
	return state.polling ?? false;
};

const customizationContainerSX = {
	w: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	textAlign: 'center',
	boxSizing: 'border-box',
	color: 'rgb(14, 14, 15)',
	opacity: 0.7,
	fontWeight: 300
};
